function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback, useMemo } from 'react';
import { useFilter } from '@react-aria/i18n';
import { useControlledState } from '@react-stately/utils';
import { collectEntryItemKeys, filterEntries, filterJsxChildrenByKeys, flattenEntriesToItems } from "./multiSelectUtils.js";
/**
 * Owns the search/filter state for `MultiSelect`. Supports controlled and
 * uncontrolled `inputValue`.
 */
export function useMultiSelectFilter(_ref) {
  var allEntries = _ref.allEntries,
    wrappedChildren = _ref.wrappedChildren,
    inputValue = _ref.inputValue,
    defaultInputValue = _ref.defaultInputValue,
    onInputChange = _ref.onInputChange,
    onSearchTextChange = _ref.onSearchTextChange;
  var _useControlledState = useControlledState(inputValue, defaultInputValue, onInputChange),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    searchText = _useControlledState2[0],
    setSearchTextInternal = _useControlledState2[1];
  var setSearchText = useCallback(value => {
    setSearchTextInternal(value);
    onSearchTextChange === null || onSearchTextChange === void 0 || onSearchTextChange(value);
  }, [setSearchTextInternal, onSearchTextChange]);
  var _useFilter = useFilter({
      sensitivity: 'base'
    }),
    contains = _useFilter.contains;
  var shouldSkipFiltering = onSearchTextChange != null || searchText === '';
  var filteredEntries = useMemo(() => {
    if (shouldSkipFiltering) {
      return allEntries;
    }
    return filterEntries(allEntries, searchText, contains);
  }, [allEntries, searchText, contains, shouldSkipFiltering]);
  var filteredItems = useMemo(() => flattenEntriesToItems(filteredEntries), [filteredEntries]);
  var filteredJsxChildren = useMemo(() => {
    if (shouldSkipFiltering) {
      return wrappedChildren;
    }
    var survivingKeys = collectEntryItemKeys(filteredEntries);
    return filterJsxChildrenByKeys(wrappedChildren, survivingKeys);
  }, [wrappedChildren, filteredEntries, shouldSkipFiltering]);
  return {
    searchText,
    setSearchText,
    filteredItems,
    filteredJsxChildren
  };
}
export default useMultiSelectFilter;
//# sourceMappingURL=useMultiSelectFilter.js.map